var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settingpage"}},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('div',{attrs:{"id":"divider"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }